/** Verify-QR payload — FR-CON-002 QR verification workflow. */

import { normalizeSafetyDigits } from "./invite";

/**
 * The safety number is commutative (identical on both devices), so a QR that
 * carries it can be scanned from either screen. The scanner compares the
 * decoded digits with its locally computed safety number for that contact —
 * a match is only possible if both devices hold the same keys.
 */
export const VERIFY_QR_PREFIX = "veto-verify:v1:";

/** Safety numbers are 60 digits today; bound leniently for future suites. */
const MIN_VERIFY_DIGITS = 30;
const MAX_VERIFY_DIGITS = 80;

/** Encode a safety number for on-screen QR display. Throws fail-closed. */
export function encodeVerifyQr(safetyNumberDigits: string): string {
  const digits = normalizeSafetyDigits(safetyNumberDigits);
  if (digits.length < MIN_VERIFY_DIGITS || digits.length > MAX_VERIFY_DIGITS) {
    throw new Error("Invalid safety number for verify QR");
  }
  return VERIFY_QR_PREFIX + digits;
}

/**
 * Decode a scanned QR into bare digits. Returns null for anything that is not
 * a Veto verify code (callers must treat null as "do not trust").
 */
export function decodeVerifyQr(raw: string): string | null {
  const trimmed = raw.trim();
  if (!trimmed.startsWith(VERIFY_QR_PREFIX)) return null;
  const digits = normalizeSafetyDigits(trimmed.slice(VERIFY_QR_PREFIX.length));
  if (digits.length < MIN_VERIFY_DIGITS || digits.length > MAX_VERIFY_DIGITS) return null;
  return digits;
}
